(function () {
  'use strict';

  angular
    .module('configDistribution')
    .config(config);

  function config($stateProvider) {
	  $stateProvider
      .state('configDistribution', {
    	sticky: true,
        url: '/config-distribution',  
        views: {
        		'configDistributionView':	{
        				templateUrl: 'config-distribution/views/config-distribution.tpl.html',
        				controller: 'ConfigDistributionCtrl',
        				controllerAs: 'configDistribution'
        			}
        	}
      });
  }
}());
